import classNames from 'classnames'
import { Link } from 'gatsby'
import React from 'react'

type NavigationProps = {
  src: Queries.SiteSettingsFragment['navigationItems']
  placement: 'Header' | 'Footer'
  open?: boolean
}

const Navigation = (props: NavigationProps) => {
  const nav = props.src

  const menuStyle = classNames('font-title xl:flex justify-center gap-x-6 uppercase text-center text-white text-lg', {
    hidden: !props.open,
    'block mt-5': props.open
  })

  return (
    <ul className={menuStyle}>
      {nav?.map((navItem) => {
        const navClass = classNames('whitespace-nowrap xl:border-c-subnav xl:hover:border-c-nav-hover', {
          'xl:relative group/item': navItem?.subNavigationItem ?? false,
          'xl:border-b-4 pb-2': props.placement === 'Header',
          'xl:border-t-4 pt-2': props.placement === 'Footer'
        })
        const subNavClass = classNames(
          'group-hover/item:xl:visible xl:invisible xl:absolute xl:px-5 xl:py-5 flex flex-col gap-y-2 xl:left-1/2 xl:-translate-x-1/2 xl:mx-auto xl:bg-c-nav-hover xl:z-40',
          {
            'xl:mt-2': props.placement === 'Header',
            'xl:bottom-full': props.placement === 'Footer'
          }
        )

        return (
          <li key={navItem?.contentful_id} className={navClass}>
            {navItem?.subNavigationItem ? (
              <>
                <span className='hidden xl:block cursor-pointer'>{navItem?.title}</span>

                <ul className={subNavClass}>
                  {navItem.subNavigationItem.map((subNav, i) => {
                    return (
                      <li key={`sub-${i}`} className='whitespace-nowrap'>
                        {subNav?.contentPage?.slug ? (
                          <Link to={`/${subNav?.contentPage?.slug}`} className='hover:xl:border-b-4 py-1 xl:border-white'>
                            {subNav?.title}
                          </Link>
                        ) : (
                          <>{subNav?.title}</>
                        )}
                      </li>
                    )
                  })}
                </ul>
              </>
            ) : (
              <>{navItem?.contentPage?.slug ? <Link to={`/${navItem?.contentPage?.slug}`}>{navItem?.title}</Link> : <>{navItem?.title}</>}</>
            )}
          </li>
        )
      })}
    </ul>
  )
}

export default Navigation
